import { useMutation } from "react-query";

import { useVersionedClient } from "contexts/versionedClient";
import { Changeset, EphemeralChangeset, EphemeralProject, Project } from "types/entities";

export const useEphemeralProject = (options = {}) => {
  const client = useVersionedClient();

  return useMutation(async (postData: EphemeralProject) => {
    const { data } = await client.post("/api/admin/ephemeral_projects", postData);
    return data as Project;
  }, options);
};

export const useCreateEphemeralProject = (options = {}) => {
  const client = useVersionedClient();

  return useMutation(async (postData: EphemeralProject) => {
    const { data } = await client.post(`/api/admin/ephemeral_projects/apply`, postData);
    return data as Project;
  }, options);
};

export const useEphemeralChangeset = (projectID: number, options = {}) => {
  const client = useVersionedClient();

  return useMutation(async (postData: EphemeralChangeset) => {
    const { data } = await client.post(
      `/api/admin/projects/${projectID}/ephemeral_changesets`,
      postData,
    );
    return data as Changeset;
  }, options);
};

export const useApplyEphemeralChangeset = (projectID: number) => {
  const client = useVersionedClient();

  return useMutation(async (postData: EphemeralChangeset) => {
    const { data } = await client.post(
      `/api/admin/projects/${projectID}/ephemeral_changesets/apply`,
      postData,
    );
    return data as Changeset;
  });
};
